const subscriptionStatuses = [
    {
        id: 'active',
        name: 'Active',
        color: '#4caf50',
        text: '#ffffff',
    },
    {
        id: 'trialing',
        name: 'Trial',
        color: '#4caf50',
        text: '#ffffff',
    },
    {
        id: 'incomplete',
        name: 'Incomplete',
        color: '#f1c40f',
        text: '#000000',
    },
    {
        id: 'past_due',
        name: 'Past Due',
        color: '#fb8c00',
        text: '#000000',
    },
    {
        id: 'paused',
        name: 'Paused',
        color: '#95a5a6',
        text: '#ffffff',
    },
    {
        id: 'unpaid',
        name: 'Unpaid',
        color: '#ff5252',
        text: '#ffffff',
    },
    {
        id: 'canceled',
        name: 'Canceled',
        color: '#ff5252',
        text: '#ffffff',
    },
    {
        id: 'incomplete_expired',
        name: 'Expired',
        color: '#ff5252',
        text: '#ffffff',
    },
];

export const subscriptionStatusMap = Object.fromEntries(
    subscriptionStatuses.map((subscription) => [subscription.id, subscription])
);

export default subscriptionStatuses;
